(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
(() => {
  const panel = document.querySelector('[data-filter-panel]');
  document.querySelectorAll('[data-filter-toggle]').forEach(b =>
    b.addEventListener('click', () => panel?.classList.toggle('is-open')));
  document.querySelectorAll('[data-filter-close]').forEach(b =>
    b.addEventListener('click', () => panel?.classList.remove('is-open')));

  // sort: preserve existing filter params
  document.querySelector('[data-sort-select]')?.addEventListener('change', e => {
    const url = new URL(location);
    url.searchParams.set('sort_by', e.target.value);
    location.href = url;
  });

  // filter form: auto-apply on any change; serialize checked boxes + price
  const form = document.querySelector('[data-filter-form]');
  function applyFilters() {
    const url = new URL(location.pathname, location.origin);
    const keep = new URL(location).searchParams.get('sort_by');
    if (keep) url.searchParams.set('sort_by', keep);
    new FormData(form).forEach((v, k) => { if (v !== '') url.searchParams.append(k, v); });
    location.href = url;
  }
  if (form) {
    form.addEventListener('submit', e => { e.preventDefault(); applyFilters(); });
    // checkboxes apply instantly; price inputs apply once committed (change)
    form.addEventListener('change', e => {
      if (e.target.matches('input[type="checkbox"], input[type="number"]')) applyFilters();
    });
  }

  // reset: clear filters, keep the current sort
  document.querySelector('[data-filter-reset]')?.addEventListener('click', () => {
    const url = new URL(location.pathname, location.origin);
    const keep = new URL(location).searchParams.get('sort_by');
    if (keep) url.searchParams.set('sort_by', keep);
    location.href = url;
  });

  // infinite loading: replace numbered pagination with auto-load-on-scroll
  const grid = document.querySelector('[data-infinite-grid]');
  const infinite = document.querySelector('[data-infinite]');
  if (grid && infinite) {
    document.querySelector('[data-cpage]')?.setAttribute('hidden', '');   // hide no-JS pager
    infinite.hidden = false;
    const btn = infinite.querySelector('[data-infinite-more]');
    const spin = infinite.querySelector('[data-infinite-spin]');
    const sentinel = document.querySelector('[data-infinite-sentinel]');
    let nextUrl = btn.dataset.nextUrl;
    let loading = false, io;

    async function loadMore() {
      if (loading || !nextUrl) return;
      loading = true;
      btn.hidden = true;
      if (spin) spin.hidden = false;
      try {
        const res = await fetch(nextUrl);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        doc.querySelectorAll('[data-infinite-grid] > *').forEach(card => grid.appendChild(card));
        const nb = doc.querySelector('[data-infinite-more]');
        nextUrl = nb ? nb.dataset.nextUrl : null;
      } catch (e) { /* keep nextUrl; user can retry via the button */ }
      loading = false;
      if (spin) spin.hidden = true;
      if (nextUrl) { btn.hidden = false; }
      else { io && io.disconnect(); infinite.remove(); sentinel && sentinel.remove(); }
    }

    btn.addEventListener('click', loadMore);
    if ('IntersectionObserver' in window && sentinel) {
      io = new IntersectionObserver(entries => { if (entries[0].isIntersecting) loadMore(); }, { rootMargin: '700px 0px' });
      io.observe(sentinel);
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-card-custom"]) return;
  try {
    
(() => {
  const root = document.currentScript.closest('section') || document.querySelector('.gc');
  if (!root) return;
  const amt = root.querySelector('[data-gc-amt]');
  root.querySelectorAll('[data-gc-variant]').forEach(inp => inp.addEventListener('change', () => {
    if (amt && inp.dataset.price) amt.textContent = inp.dataset.price;
  }));
  const toggle = root.querySelector('[data-gc-gift-toggle]');
  const fields = root.querySelector('[data-gc-gift-fields]');
  const flag = root.querySelector('[data-gc-gift-flag]');
  toggle?.addEventListener('change', () => {
    fields.hidden = !toggle.checked;
    if (flag) flag.value = toggle.checked ? 'on' : '';
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(() => {
  const header = document.querySelector('.hdr');
  if (!header) return;

  // fish blows a bubble every 5-15s (random size, drift, duration)
  const bubble = header.querySelector('[data-bubble]');
  if (bubble && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const blow = () => {
      const size = (5 + Math.random() * 4).toFixed(1);
      bubble.style.setProperty('--b-size', size + 'px');
      bubble.style.setProperty('--b-drift', (1 + Math.random() * 6).toFixed(1) + 'px');
      bubble.style.setProperty('--b-dur', (1.8 + Math.random() * 0.9).toFixed(2) + 's');
      bubble.classList.remove('is-blowing');
      void bubble.offsetWidth;            // restart the animation
      bubble.classList.add('is-blowing');
      setTimeout(blow, 5000 + Math.random() * 10000);
    };
    setTimeout(blow, 1500 + Math.random() * 3000);
  }

  // mobile drawer
  const panel = header.querySelector('[data-nav-panel]');
  header.querySelectorAll('[data-nav-toggle]').forEach(btn => btn.addEventListener('click', () => {
    const open = panel.hidden;
    panel.hidden = !open;
    document.documentElement.classList.toggle('no-scroll', open);
    header.querySelector('.hdr__burger').setAttribute('aria-expanded', String(open));
  }));

  // shared predictive fetch
  const suggest = async q => {
    const r = await fetch(`${window.Shopify?.routes?.root || '/'}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8`);
    const d = await r.json();
    return d?.resources?.results?.products || [];
  };
  const imgOf = p => {
    const f = p.featured_image || p.image;
    const u = f && (f.url || f);
    if (!u) return '';
    return u + (u.includes('?') ? '&' : '?') + 'width=92';
  };
  const renderHits = (hits, q) => hits.length
    ? `<div class="psearch__grid">${hits.map(p => {
        const u = imgOf(p);
        return `<a class="psearch__hit" href="${p.url}">
          ${u ? `<img src="${u}" alt="${(p.title || '').replace(/"/g, '&quot;')}" loading="lazy" width="46" height="46">` : '<span class="psearch__hit-noimg"></span>'}
          <span><span class="psearch__hit-title">${p.title}</span><br><span class="psearch__hit-price">${p.price || ''}</span></span>
        </a>`; }).join('')}</div>
       <a class="psearch__all" href="/search?q=${encodeURIComponent(q)}">All results for "${q}" →</a>`
    : `<p style="color:var(--c-ink-mute);margin:0;padding:8px">No products match "${q}".</p>`;

  const wire = (input, out) => {
    if (!input || !out) return;
    let t;
    input.addEventListener('input', () => {
      clearTimeout(t);
      const q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; out.hidden = true; return; }
      t = setTimeout(async () => {
        try { out.innerHTML = renderHits(await suggest(q), q); out.hidden = false; } catch (_) {}
      }, 200);
    });
    document.addEventListener('click', e => { if (!e.target.closest('[data-search-wrap], [data-msearch-panel]')) out.hidden = true; });
    input.addEventListener('focus', () => { if (out.innerHTML) out.hidden = false; });
  };
  wire(header.querySelector('[data-search-input]'), header.querySelector('[data-search-results]'));
  wire(header.querySelector('[data-msearch-input]'), header.querySelector('[data-msearch-results]'));

  // mobile search sheet
  const ms = header.querySelector('[data-msearch-panel]');
  header.querySelectorAll('[data-msearch-toggle]').forEach(b => b.addEventListener('click', () => {
    ms.hidden = !ms.hidden;
    if (!ms.hidden) header.querySelector('[data-msearch-input]').focus();
  }));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { ms.hidden = true; } });

  // touch: first tap opens panel, second follows
  header.querySelectorAll('.rail__item.has-panel > .rail__link').forEach(link => {
    link.addEventListener('click', e => {
      const li = link.parentElement;
      if (matchMedia('(hover: none)').matches && !li.classList.contains('is-open')) {
        e.preventDefault();
        header.querySelectorAll('.rail__item.is-open').forEach(o => o.classList.remove('is-open'));
        li.classList.add('is-open');
        link.setAttribute('aria-expanded', 'true');
      }
    });
  });
  document.addEventListener('click', e => {
    if (!e.target.closest('.rail__item.has-panel')) {
      header.querySelectorAll('.rail__item.is-open').forEach(o => o.classList.remove('is-open'));
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-immersive"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const hero = document.querySelector('.ihero');
  const f1el = hero && hero.querySelector('.ihero__fish');
  if (!hero || !f1el) return;

  const layer = document.createElement('div');
  layer.className = 'ihero__pellets';
  hero.querySelector('.ihero__bg').appendChild(layer);

  let W = hero.clientWidth, H = hero.clientHeight;
  addEventListener('resize', () => { W = hero.clientWidth; H = hero.clientHeight; });
  const R = (a, b) => a + Math.random() * (b - a);

  class Fish {
    constructor(el) { this.el = el; this.x = -300; this.y = H * 0.3; this.vx = 0; this.vy = 0; this.a = 0; this.w = el.offsetWidth || 220; }
    seek(tx, ty, maxV, acc, dt) {
      const dx = tx - this.x, dy = ty - this.y, d = Math.hypot(dx, dy) || 1;
      this.vx += (dx / d) * acc * dt; this.vy += (dy / d) * acc * dt;
      const v = Math.hypot(this.vx, this.vy);
      if (v > maxV) { this.vx *= maxV / v; this.vy *= maxV / v; }
    }
    drag(k, dt) { const f = Math.max(0, 1 - k * dt); this.vx *= f; this.vy *= f; }
    step(dt, faceVel) {
      this.x += this.vx * dt; this.y += this.vy * dt;
      if (faceVel !== false && Math.hypot(this.vx, this.vy) > 12) {
        const want = Math.atan2(this.vy, this.vx);
        let delta = want - this.a;
        while (delta > Math.PI) delta -= 2 * Math.PI;
        while (delta < -Math.PI) delta += 2 * Math.PI;
        this.a += delta * Math.min(1, dt * 5);
      }
      this.render(0);
    }
    render(extraDeg, sc) {
      const deg = this.a * 180 / Math.PI + (extraDeg || 0);
      const norm = ((deg % 360) + 360) % 360;
      const flip = (norm > 90 && norm < 270) ? ' scaleY(-1)' : '';
      const scale = sc ? ' scale(' + sc + ')' : '';
      this.el.style.transform = 'translate(' + (this.x - this.w / 2) + 'px,' + (this.y - this.w * 0.23) + 'px) rotate(' + deg + 'deg)' + flip + scale;
    }
  }

  const f1 = new Fish(f1el);
  f1el.classList.add('is-live');
  let f2 = null, pellets = [], scene = 'swim', st = {}, order = [];

  // 5 clicks on the fish = it becomes yours and follows the mouse
  const mouse = { x: 0, y: 0, seen: -10 };
  addEventListener('pointermove', (e) => {
    const rc = hero.getBoundingClientRect();
    mouse.x = e.clientX - rc.left; mouse.y = e.clientY - rc.top;
    if (mouse.x >= 0 && mouse.y >= 0 && mouse.x <= rc.width && mouse.y <= rc.height) mouse.seen = performance.now() / 1000;
  });
  let clicks = 0, lastClick = 0;
  f1el.addEventListener('click', () => {
    const now = performance.now() / 1000;
    clicks = (now - lastClick < 2.5) ? clicks + 1 : 1;
    lastClick = now;
    if (clicks >= 5 && scene !== 'follow') {
      if (f2) { f2.el.remove(); f2 = null; }
      for (const p of pellets) p.el.remove();
      pellets = [];
      scene = 'follow'; st = {};
      clicks = 0;
    }
  });

  const nextScene = () => {
    if (!order.length) order = ['pellets', 'spiral', 'peck'].sort(() => Math.random() - 0.5);
    return order.pop();
  };
  const startSwim = () => { scene = 'swim'; st = { target: null }; };

  const scenes = {
    follow(dt) {
      const now = performance.now() / 1000;
      if (now - mouse.seen > 2) { startSwim(); return; } // lost you - back to business, exit right
      const dist = Math.hypot(mouse.x - f1.x, mouse.y - f1.y);
      if (dist > 40) f1.seek(mouse.x, mouse.y, Math.min(W * 0.38, 90 + dist * 2.2), 2400, dt);
      else f1.drag(3, dt);
      f1.step(dt);
    },

    swim(dt) {
      // dart -> glide -> rest rhythm; watchdog guarantees progress
      if (!st.mode) { st.mode = 'rest'; st.t = 0.2; }
      st.t -= dt;
      if (f1.x > W + 150) {
        f1.x = -180; f1.y = R(H * 0.15, H * 0.5); f1.vx = 160; f1.vy = 0; f1.a = 0;
        scene = nextScene(); st = {};
        return;
      }
      if (st.mode === 'burst') {
        f1.seek(st.target[0], st.target[1], W * 0.34, 1900, dt);
        if (st.t <= 0 || Math.hypot(st.target[0] - f1.x, st.target[1] - f1.y) < 70) { st.mode = 'glide'; st.t = 1.1; }
      } else if (st.mode === 'glide') {
        f1.drag(1.6, dt);
        if (st.t <= 0 || Math.hypot(f1.vx, f1.vy) < 60) { st.mode = 'rest'; st.t = R(0.25, 0.8); }
      } else { // rest: hang in the water, then pick the next dart
        f1.drag(2.5, dt);
        if (st.t <= 0) {
          st.target = [f1.x + R(W * 0.16, W * 0.3), Math.min(H * 0.62, Math.max(H * 0.12, f1.y + R(-H * 0.18, H * 0.18)))];
          st.mode = 'burst'; st.t = R(0.35, 0.55);
        }
      }
      f1.step(dt);
    },

    pellets(dt) {
      if (!st.init) { st.init = true; st.toDrop = 5; st.dropT = 0.2; st.phase = 'calm'; st.calmT = R(1.2, 2.0); }
      if (st.toDrop > 0) {
        st.dropT -= dt;
        if (st.dropT <= 0) {
          st.dropT = R(0.5, 0.9); st.toDrop--;
          const el = document.createElement('span');
          el.className = 'ihero__pellet';
          layer.appendChild(el);
          pellets.push({ el: el, x: R(W * 0.62, W * 0.94), y: -12, vy: R(210, 300), vx: R(-14, 6), ph: R(0, 6.28), fl: R(1.5, 2.6) });
        }
      }
      for (const p of pellets) {
        p.vy += (55 - p.vy) * Math.min(1, dt * 1.6);
        p.ph += p.fl * dt;
        p.x += (p.vx + Math.sin(p.ph) * 12) * dt;
        p.y += p.vy * dt;
        p.el.style.transform = 'translate(' + p.x + 'px,' + p.y + 'px) rotate(' + (p.ph * 40) + 'deg)';
        if (!p.ate && p.y > H * 0.88) {
          p.ate = true; // settled into the substrate - fade, don't fall forever
          p.el.style.opacity = '0';
          (el => setTimeout(() => el.remove(), 300))(p.el);
        }
      }
      const live = pellets.filter(p => !p.ate && p.y < H * 0.92);
      // phase 1: cruise calmly, oblivious, while food starts to fall
      if (st.phase === 'calm') {
        st.calmT -= dt;
        f1.vx += (W * 0.05 - f1.vx) * Math.min(1, dt * 1.5);
        f1.vy += (Math.sin((st.calmT * 2.1)) * 24 - f1.vy) * Math.min(1, dt * 2);
        f1.step(dt);
        if (st.calmT <= 0 && live.length && live[0].y > H * 0.12) { st.phase = 'spot'; st.spotT = 0.38; }
        return;
      }
      // phase 2: the freeze - it just noticed dinner
      if (st.phase === 'spot') {
        st.spotT -= dt;
        f1.drag(4.5, dt);
        if (live.length) {
          const want = Math.atan2(live[0].y - f1.y, live[0].x - f1.x);
          let dd = want - f1.a;
          while (dd > Math.PI) dd -= 2 * Math.PI;
          while (dd < -Math.PI) dd += 2 * Math.PI;
          f1.a += dd * Math.min(1, dt * 3);
        }
        f1.step(dt, false);
        if (st.spotT <= 0) st.phase = 'feed';
        return;
      }
      if (live.length) {
        // everything is anchored to the MOUTH: the far tip of the nose
        const M = f1.w * 0.44;
        const mouth = () => [f1.x + Math.cos(f1.a) * M, f1.y + Math.sin(f1.a) * M];
        let [mx, my] = mouth();
        let tgt = live[0], best = 1e9;
        for (const p of live) { const d = Math.hypot(p.x - mx, p.y - my); if (d < best) { best = d; tgt = p; } }
        if (best < f1.w * 1.0) {
          // hairpin zone: pivot on a needle - heading snaps straight onto the
          // pellet and the approach is kinematic, so orbiting is impossible
          f1.a = Math.atan2(tgt.y - f1.y, tgt.x - f1.x);
          const sp = Math.min(W * 0.2, 70 + best * 2.5);
          f1.vx = Math.cos(f1.a) * sp; f1.vy = Math.sin(f1.a) * sp;
          f1.x += f1.vx * dt; f1.y += f1.vy * dt;
          f1.render(0);
        } else {
          // far approach: steer the point the mouth will occupy, not the body
          f1.seek(tgt.x - Math.cos(f1.a) * M, tgt.y - Math.sin(f1.a) * M, W * 0.28, 1400, dt);
          f1.step(dt);
        }
        [mx, my] = mouth();
        if (Math.hypot(tgt.x - mx, tgt.y - my) < 15) {
          tgt.ate = true;
          tgt.el.style.transition = 'transform 0.25s, opacity 0.25s';
          tgt.el.style.transform += ' scale(2.4)'; // pop in place - inside the transform list
          tgt.el.style.opacity = '0';
          (el => setTimeout(() => el.remove(), 260))(tgt.el);
        }
        pellets = pellets.filter(p => !p.ate);
        return;
      } else if (st.toDrop <= 0) {
        for (const p of pellets) p.el.remove();
        pellets = []; startSwim();
        return;
      }
      pellets = pellets.filter(p => !p.ate);
      f1.step(dt);
    },

    spiral(dt) {
      if (!st.init) {
        st.init = true; st.phase = 'in';
        const el = f1el.cloneNode(true);
        el.classList.add('ihero__fish--b'); el.classList.add('is-live');
        f1el.parentNode.appendChild(el);
        f2 = new Fish(el);
        f2.x = W + 200; f2.y = R(H * 0.78, H * 0.9); f2.a = Math.PI;
        st.mp = [W * R(0.42, 0.58), H * 0.78]; // low rendezvous - the fight starts at the bottom
      }
      if (st.phase === 'in') {
        const mx = st.mp[0], my = st.mp[1];
        f1.seek(mx, my, W * 0.3, 1500, dt); f2.seek(mx, my, W * 0.3, 1500, dt);
        f1.step(dt); f2.step(dt);
        if (Math.hypot(f1.x - f2.x, f1.y - f2.y) < f1.w * 0.9) {
          st.phase = 'spin';
          st.cx = mx; st.cy = my;
          st.th = Math.atan2(f1.y - my, f1.x - mx);
          st.rx = f1.w * 0.72; st.spun = 0;
        }
      } else if (st.phase === 'spin') {
        // side-view whirlpool: flat ellipse around a vertical axis, rising;
        // near side renders bigger/brighter/in front, far side small/dim/behind
        const spd = 2.7;
        st.th += spd * dt; st.spun += spd * dt;
        st.cy -= H * 0.055 * dt; // slower climb - let the fight breathe
        st.rx = Math.max(f1.w * 0.42, st.rx - 16 * dt);
        const ry = st.rx * 0.26;
        const place = (fish, th) => {
          const depth = Math.sin(th); // +1 = near side (front of the vortex)
          fish.x = st.cx + Math.cos(th) * st.rx;
          fish.y = st.cy + depth * ry;
          // perspective turn: yaw about the vertical axis follows the travel
          // direction in the horizontal plane, so the fish turns through
          // edge-on at the sides of the vortex - no hard mirror flip
          const dx = -Math.sin(th), dz = Math.cos(th), dy = dz * 0.26;
          const yaw = Math.atan2(-dz, dx) * 180 / Math.PI; // CSS rotateY: nose lands at (cos, -sin) in x/z
          const pitch = (dx >= 0 ? 1 : -1) * Math.max(-20, Math.min(20, Math.atan2(dy, Math.abs(dx) + 0.15) * 180 / Math.PI));
          const sc = 1 + depth * 0.16;
          fish.a = dx >= 0 ? 0 : Math.PI; // keep heading sane for the exit phase
          fish.el.style.transform = 'translate(' + (fish.x - fish.w / 2) + 'px,' + (fish.y - fish.w * 0.23) + 'px) perspective(900px) rotateY(' + yaw + 'deg) rotate(' + pitch + 'deg) scale(' + sc + ')';
          fish.el.style.opacity = 0.62 + (depth + 1) * 0.19;
          fish.el.style.zIndex = depth > 0 ? 5 : 3;
        };
        place(f1, st.th); place(f2, st.th + Math.PI);
        if (st.spun > 7 * Math.PI || st.cy < H * 0.16) {
          st.phase = 'out';
          for (const fx of [f1, f2]) { fx.el.style.opacity = ''; fx.el.style.zIndex = ''; }
          f2.vx = 260; f2.vy = -60; f1.vx = -120; f1.vy = 60;
        }
      } else {
        f2.seek(W + 300, -80, W * 0.45, 1800, dt); f2.step(dt);
        f1.drag(0.6, dt); f1.step(dt);
        if (f2.x > W + 220) { f2.el.remove(); f2 = null; startSwim(); }
      }
    },

    peck(dt) {
      if (!st.init) {
        st.init = true; st.gy = H - f1.w * 0.42; st.next = 0.6; st.pk = -1; st.bob = 0;
        st.dir = 1; st.backFor = 0; st.turned = false; st.backX = 0; st.catchup = false;
        if (f1.x > W * 0.55 || f1.x < -200) { f1.x = -150; f1.y = H * 0.86; }
        f1.vx = 220; f1.vy = 40; // swim in, no teleport
      }
      st.bob += dt * 1.7;
      if (st.backFor > 0) {
        st.backFor -= dt;
        if (st.backFor <= 0) { st.dir = 1; st.catchup = true; } // done - hustle back to the spot it left
      }
      if (st.catchup && f1.x >= st.backX) st.catchup = false;
      const drift = W * 0.032 * st.dir * (st.catchup ? 2 : 1);
      f1.vx += (drift - f1.vx) * Math.min(1, dt * 2);
      const wantY = st.gy + Math.sin(st.bob) * 9;
      f1.vy += ((wantY - f1.y) * 2 - f1.vy) * Math.min(1, dt * 3);
      f1.x += f1.vx * dt; f1.y += f1.vy * dt;
      st.next -= dt;
      let peckDeg = 0;
      if (st.pk >= 0) {
        st.pk += dt / 0.55;
        if (st.pk >= 1) {
          st.pk = -1; st.next = R(0.6, 1.3);
          // missed one behind? pivot right around and go back for it
          if (st.dir === 1 && !st.turned && st.backFor <= 0 && Math.random() < 0.35 && f1.x > W * 0.18) {
            st.dir = -1; st.backFor = R(1.2, 2.2);
            st.turned = true; st.backX = f1.x; // once per crossing
          }
        }
        else peckDeg = 22 * Math.sin(Math.PI * st.pk);
      } else if (st.next <= 0) st.pk = 0;
      // grazing posture: nose down ~57deg, TAIL UP - mirrored when working backwards;
      // the turn lerps through straight-down, pivoting around the nose
      const baseA = st.dir === 1 ? 1.0 : Math.PI - 1.0;
      let da = baseA - f1.a;
      while (da > Math.PI) da -= 2 * Math.PI;
      while (da < -Math.PI) da += 2 * Math.PI;
      f1.a += da * Math.min(1, dt * 3.2);
      f1.render(peckDeg * st.dir);
      if (f1.x > W * 0.86) startSwim();
    }
  };

  let last = performance.now();
  const loop = (now) => {
    const dt = Math.min(0.05, (now - last) / 1000);
    last = now;
    st.age = (st.age || 0) + dt;
    if (st.age > 25 && scene !== 'swim' && scene !== 'follow') { // watchdog: no scene may stall
      if (f2) { f2.el.remove(); f2 = null; }
      for (const p of pellets) p.el.remove();
      pellets = []; startSwim();
    }
    (scenes[scene] || scenes.swim)(dt);
    requestAnimationFrame(loop);
  };
  f1.y = R(H * 0.18, H * 0.45);
  startSwim();
  requestAnimationFrame(loop);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
(() => {
  const main = document.querySelector('[data-product-main]');
  if (!main) return;
  const mainImg = main.querySelector('#MainImage');
  const stage = main.querySelector('[data-gallery-stage]');
  const thumbs = [...main.querySelectorAll('.pdp__thumb')];
  const images = thumbs.length ? thumbs.map(t => t.dataset.full) : (mainImg ? [mainImg.src] : []);
  let current = 0;

  function setImage(i) {
    current = (i + images.length) % images.length;
    if (mainImg) mainImg.src = images[current];
    thumbs.forEach((t, idx) => t.classList.toggle('is-active', idx === current));
  }
  thumbs.forEach((t, idx) => t.addEventListener('click', () => setImage(idx)));

  // hover zoom (desktop, fine pointer)
  if (stage && matchMedia('(hover: hover) and (pointer: fine)').matches) {
    stage.addEventListener('mousemove', e => {
      if (!stage.classList.contains('is-zoomed')) return;
      const r = stage.getBoundingClientRect();
      mainImg.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
    });
    stage.addEventListener('mouseleave', () => { stage.classList.remove('is-zoomed'); mainImg.style.transform = ''; });
  }

  // lightbox
  const lb = document.querySelector('[data-lightbox]');
  const lbImg = lb?.querySelector('[data-lightbox-img]');
  const openLb = () => { if (!lb) return; lbImg.src = images[current]; lb.hidden = false; document.documentElement.classList.add('no-scroll'); toggleNav(); };
  const closeLb = () => { if (!lb) return; lb.hidden = true; document.documentElement.classList.remove('no-scroll'); };
  const toggleNav = () => { lb?.querySelectorAll('.pdp-lb__nav').forEach(n => n.hidden = images.length < 2); };
  main.querySelector('[data-lightbox-open]')?.addEventListener('click', e => { e.stopPropagation(); openLb(); });

  // stage click: zoom on desktop, lightbox on touch
  stage?.addEventListener('click', e => {
    if (e.target.closest('[data-lightbox-open]')) return;
    if (matchMedia('(hover: hover) and (pointer: fine)').matches) {
      const z = stage.classList.toggle('is-zoomed');
      mainImg.style.transform = z ? 'scale(2)' : '';
    } else { openLb(); }
  });

  if (lb) {
    lb.querySelector('[data-lightbox-close]').addEventListener('click', closeLb);
    lb.querySelector('[data-lightbox-prev]').addEventListener('click', () => { setImage(current - 1); lbImg.src = images[current]; });
    lb.querySelector('[data-lightbox-next]').addEventListener('click', () => { setImage(current + 1); lbImg.src = images[current]; });
    lb.addEventListener('click', e => { if (e.target === lb) closeLb(); });
    document.addEventListener('keydown', e => {
      if (lb.hidden) return;
      if (e.key === 'Escape') closeLb();
      if (e.key === 'ArrowLeft') { setImage(current - 1); lbImg.src = images[current]; }
      if (e.key === 'ArrowRight') { setImage(current + 1); lbImg.src = images[current]; }
    });
  }

  // qty stepper
  const qty = main.querySelector('[data-qty-input]');
  main.querySelectorAll('[data-qty-step]').forEach(b => b.addEventListener('click', () => {
    qty.value = Math.max(1, Number(qty.value || 1) + Number(b.dataset.qtyStep));
  }));

  // variant-description app content REPLACES the product description: while the
  // app block has content the base description hides; empty block restores it
  const appDesc = main.querySelector('[data-appdesc]');
  if (appDesc) {
    const visText = () => {
      // the app block carries an invisible JSON payload in a <script> - count only renderable text
      const c = appDesc.cloneNode(true);
      c.querySelectorAll('script, style, template, noscript').forEach(n => n.remove());
      return c.textContent.trim();
    };
    const swap = () => {
      const has = visText() !== '';
      appDesc.hidden = !has;
      const base = main.querySelector('[data-base-desc]') || main.querySelector('[data-vdesc-base]');
      const nativeShown = main.querySelector('[data-vdesc]:not([hidden])');
      if (base) base.hidden = has || !!nativeShown;
    };
    swap();
    new MutationObserver(swap).observe(appDesc, { subtree: true, childList: true, characterData: true });
  }

  // tank pre-order quote modal
  const prefModal = main.querySelector('[data-tank-preorder-modal]');
  const preOpen = main.querySelector('[data-tank-preorder-open]');
  if (prefModal) {
    if (preOpen) preOpen.addEventListener('click', () => {
      const q = prefModal.querySelector('[data-pref-qty]');
      if (q && qty) q.value = qty.value;
      prefModal.showModal();
    });
    prefModal.querySelector('[data-pref-close]').addEventListener('click', () => prefModal.close());
    prefModal.addEventListener('click', e => { if (e.target === prefModal) prefModal.close(); });
    // reopen after a submit round-trip so the success / error state is visible
    if (prefModal.querySelector('[data-pref-autopen]')) prefModal.showModal();
  }

  // product enquiry modal (enquire-only items: instore-only / quote-only)
  const enqModal = main.querySelector('[data-enquire-modal]');
  if (enqModal) {
    const enqOpen = main.querySelector('[data-enquire-open]');
    if (enqOpen) enqOpen.addEventListener('click', () => enqModal.showModal());
    enqModal.querySelector('[data-pref-close]').addEventListener('click', () => enqModal.close());
    enqModal.addEventListener('click', e => { if (e.target === enqModal) enqModal.close(); });
    if (enqModal.querySelector('[data-pref-autopen]')) enqModal.showModal();
  }

  // variant resolution
  const json = main.querySelector('[data-variants-json]');
  if (!json) return;
  const variants = JSON.parse(json.textContent);
  const idInput = main.querySelector('[data-variant-id]');
  const priceBox = main.querySelector('[data-price]');
  const saveBox = main.querySelector('[data-save]');
  const stockBox = main.querySelector('[data-stock]');
  const atc = main.querySelector('button[type="submit"].pdp__atc');
  // a booking button belongs to the app once it converts it - never relabel it
  const isService = !!(idInput && idInput.dataset.service);
  const label = main.querySelector('[data-atc-label]');
  const money = c => new Intl.NumberFormat(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD' }).format(c / 100);

  main.querySelectorAll('[data-option-input]').forEach(inp => inp.addEventListener('change', () => {
    const chosen = [...main.querySelectorAll('[data-option-input]:checked')].map(i => i.value);
    const v = variants.find(v => chosen.every((val, i) => v.options[i] === val));
    if (!v) return;
    idInput.value = v.id;
    // standard hooks for app scripts (variant-description apps etc.): a bubbling
    // change on the variant id input plus a documented custom event
    idInput.dispatchEvent(new Event('change', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('variant:changed', { detail: { product: { handle: location.pathname.split('/').pop() }, variant: v }, bubbles: true }));
    const onSale = v.compare_at_price > v.price;
    priceBox.innerHTML = `<span class="price ${onSale ? 'price--sale' : ''}">
      <span class="price__now">${money(v.price)}</span>
      ${onSale ? `<s class="price__was">${money(v.compare_at_price)}</s>` : ''}</span>`;
    if (saveBox) {
      if (onSale) { saveBox.hidden = false; saveBox.textContent = `Save ${money(v.compare_at_price - v.price)} (${Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price)}%)`; }
      else saveBox.hidden = true;
    }
    const apAmt = main.querySelector('[data-afterpay-amt]');
    if (apAmt) apAmt.textContent = money(v.price / 4);
    if (atc && !isService) { // enquire-only layouts have no cart button and a static stock line
      stockBox.innerHTML = v.available
        ? '<span class="stockdot stockdot--in"></span> In stock, ready to ship'
        : (preOpen ? '<span class="stockdot stockdot--soon"></span> Available to pre-order'
                   : '<span class="stockdot stockdot--out"></span> Sold out');
      atc.disabled = !v.available;
      label.textContent = v.available ? 'Add to cart' : 'Sold out';
    }
    if (preOpen) {
      const always = preOpen.hasAttribute('data-pref-always');
      preOpen.hidden = always ? false : v.available;
      atc.hidden = always || !v.available;
    }
    const prefVariant = main.querySelector('[data-pref-variant]');
    if (prefVariant) prefVariant.value = v.title;
    const enqVariant = main.querySelector('[data-enq-variant]');
    if (enqVariant) enqVariant.value = v.title;
    // variant description swap: show the selected variant's description, else the base
    const vdescs = main.querySelectorAll('[data-vdesc]');
    if (vdescs.length) {
      let shown = false;
      vdescs.forEach(el => {
        const on = el.dataset.vdesc === String(v.id);
        el.hidden = !on;
        if (on) shown = true;
      });
      const baseDesc = main.querySelector('[data-vdesc-base]');
      if (baseDesc) baseDesc.hidden = shown;
    }
    if (v.featured_image && v.featured_image.src) {
      const idx = images.findIndex(u => u.split('?')[0] === v.featured_image.src.split('?')[0]);
      if (idx >= 0) setImage(idx); else if (mainImg) mainImg.src = v.featured_image.src;
    }
    const url = new URL(location); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
  }));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
(() => {
  const sel = document.querySelector('[data-search-sort]');
  sel && sel.addEventListener('change', e => {
    const u = new URL(location); u.searchParams.set('sort_by', e.target.value); location.href = u;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["service-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('.svcp');
  if (!root) return;
  const json = root.querySelector('[data-svcp-variants]');
  if (!json) return;
  const variants = JSON.parse(json.textContent);
  const idInput = root.querySelector('[data-svcp-id]');
  const priceBox = root.querySelector('[data-svcp-price]');
  const money = c => new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD'
  }).format(c / 100);

  root.querySelectorAll('[data-svcp-option]').forEach(inp => inp.addEventListener('change', () => {
    const chosen = [...root.querySelectorAll('[data-svcp-option]:checked')].map(i => i.value);
    const v = variants.find(x => chosen.every((val, i) => x.options[i] === val));
    if (!v) return;
    idInput.value = v.id;
    // the booking app re-reads the variant from a real change event on the id input
    idInput.dispatchEvent(new Event('change', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('variant:changed', {
      detail: { product: { handle: location.pathname.split('/').pop() }, variant: v }, bubbles: true }));
    if (priceBox) priceBox.textContent = v.price === 0 ? 'Free' : money(v.price);
  }));
})();

  } catch(e) { console.error(e); }
})();
})();
